export default __webpack_public_path__ + "static/media/Documentos-afiliacion-banco-solidario.4a2e3328.pdf";